import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatKeyText(text: string): string {
  return text
    .replace(/[-_]/g, " ") // Replace underscores with spaces
    .replace(/\b(\w+)/g, (match) => {
      // Capitalize the first letter of words
      return match.charAt(0).toUpperCase() + match.slice(1).toLowerCase();
    });
}

export function removeSpacesAndHyphens(text: string) {
  return text.replace(/[\s-]/g, "");
}

export function stripTextAfterHyphen(text: string) {
  const hyphenIndex = text.indexOf("-");

  if (hyphenIndex === -1) {
    return text; // Return the original text if no hyphen is found
  }

  return text.substring(0, hyphenIndex); // Return the text before the hyphen
}

export function getNameInitials(name: string): string {
  return name
    .split(" ")
    .map((part) => part.charAt(0).toUpperCase())
    .join("");
}

export const isValidId = (id?: string) => {
  if (!id) return false;
  return !Number.isNaN(Number(id));
};

export const noop = () => undefined;
